import { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";
import PublicNav from "../../components/layout/PublicNav";
import Footer from "../../components/layout/Footer";
import { api } from "../../lib/api";

export default function ImportantLinksPage() {
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/important-links")
      .then(r => setLinks(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="App">
      <PublicNav />

      {/* Hero */}
      <section className="py-12 md:py-16 px-6 md:px-12" style={{ background: "#1A1A1A" }}>
        <div className="max-w-7xl mx-auto">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold tracking-wider uppercase mb-5" style={{ background: "rgba(220,42,28,0.2)", color: "#DC2A1C" }}>
            <span className="w-1.5 h-1.5 rounded-full" style={{ background: "#DC2A1C" }} /> Resources
          </div>
          <h1 className="text-4xl sm:text-5xl font-black tracking-tighter text-white mb-3">Important Links</h1>
          <p className="text-lg max-w-2xl" style={{ color: "rgba(255,255,255,0.6)" }}>
            A curated directory of trade portals, customs systems, and logistics resources.
          </p>
        </div>
      </section>

      {/* Links grid */}
      <section className="py-12 md:py-16 px-6 md:px-12" style={{ background: "#F8F9FA" }}>
        <div className="max-w-7xl mx-auto">
          {loading ? (
            <div className="text-gray-400 text-sm">Loading…</div>
          ) : links.length === 0 ? (
            <div className="text-center py-20">
              <div className="text-4xl mb-4">🔗</div>
              <p className="text-gray-500">No links added yet. Check back soon.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
              {links.map(link => (
                <a
                  key={link.id}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group bg-white border border-gray-100 rounded-xl overflow-hidden shadow-sm hover:-translate-y-1 hover:shadow-md transition-all duration-300 flex flex-col"
                >
                  {link.image_url ? (
                    <div className="aspect-[16/9] overflow-hidden bg-gray-50">
                      <img
                        src={link.image_url}
                        alt={link.title}
                        className="w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                  ) : (
                    <div className="aspect-[16/9] flex items-center justify-center" style={{ background: "rgba(220,42,28,0.06)" }}>
                      <ExternalLink className="w-10 h-10" style={{ color: "#DC2A1C", opacity: 0.4 }} />
                    </div>
                  )}
                  <div className="p-4 flex-1 flex flex-col">
                    <h3 className="font-semibold text-sm mb-1" style={{ color: "#1A1A1A" }}>{link.title}</h3>
                    {link.description && (
                      <p className="text-xs text-gray-500 line-clamp-2 flex-1">{link.description}</p>
                    )}
                    <div className="flex items-center gap-1 mt-3 text-xs font-semibold" style={{ color: "#DC2A1C" }}>
                      Visit <ExternalLink className="w-3 h-3" />
                    </div>
                  </div>
                </a>
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}
